import { getBuildingsNG } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../Building.constants'
import { toBuildingSelectItems } from '../Building.utils'

import BuildingIcon from '../../../icons/building.svg'

function BuildingSelect({
  Control = InputSelectControl,
  apiParams = BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  getData = getBuildingsNG,
  getDataItems = getItemsFromIdwellApiResponse,
  toPreparedItems = toBuildingSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      EntityIcon={BuildingIcon}
      apiParams={apiParams}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default BuildingSelect
